import { Routes } from '@angular/router';
import { authRoutes } from './features/auth/auth.routes';
import { authGuard } from './core/auth/guards/auth.guard';
import { permissionGuard } from './core/auth/guards/permission.guard';
import { landingGuard } from './core/auth/guards/landing.guard';
import { MainLayout } from './layout/main-layout/main-layout';

export const routes: Routes = [
  ...authRoutes,

  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.routes),
      },
      {
        path: 'dashboard-tec',
        loadChildren: () =>
          import('./features/dashboard-tec/dashboard-tec.routes').then(
            (m) => m.DASHBOARD_TEC_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'DashboardTec' },
      },
      {
        // Alertas do fechamento. Mesma permissão de Operações: quem importa
        // extrato e concilia é quem precisa ver a divergência de saldo.
        path: 'alertas',
        loadChildren: () =>
          import('./features/alertas/alertas.routes').then((m) => m.ALERTAS_ROUTES),
        canActivate: [permissionGuard],
        data: { permissao: 'Operacoes' },
      },
      {
        path: 'empreendimentos',
        loadChildren: () =>
          import('./features/cadastros/empreendimentos/empreendimentos.routes').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'Empreendimentos' },
      },
      {
        // Investidor e Incorporador viraram papéis do cadastro de Empresa.
        path: 'empresa',
        loadChildren: () =>
          import('./features/cadastros/empresa/empresa.routes').then((m) => m.EMPRESA_ROUTES),
        canActivate: [permissionGuard],
        data: { permissao: 'Investidores' },
      },
      { path: 'incorporador', redirectTo: 'empresa', pathMatch: 'full' },
      { path: 'investidor', redirectTo: 'empresa', pathMatch: 'full' },
      {
        path: 'feriados',
        loadChildren: () =>
          import('./features/cadastros/feriados/feriados.route').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'feriados' },
      },
      {
        // Configurações > Escopos: usa a permissão de Empreendimentos.
        path: 'escopos',
        loadChildren: () =>
          import('./features/cadastros/escopos/escopos.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'Empreendimentos' },
      },
      {
        path: 'classificacoes-contas-pagas',
        loadChildren: () =>
          import('./features/cadastros/classificacoes-contas-pagas/classificacoes-contas-pagas.routes').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'ClassificacoesContasPagas' },
      },
      // Antes de 'operacoes' (que carrega as rotas de Diferenças) para o prefixo não engolir esta.
      {
        path: 'operacoes/espelho-vendas',
        loadChildren: () =>
          import('./features/operacoes/espelho-vendas/espelho-vendas.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'EspelhoVendas' },
      },
      {
        path: 'operacoes',
        loadChildren: () =>
          import('./features/operacoes/movimento-empreendimento/movimento-empreendimento.routes').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'Operacoes' },
      },
      // Mapeamento: Novas Conversões (regras de conversão criadas pela IA) e a
      // validação dessas regras pela equipe de inovação.
      {
        path: 'mapeamento/novas-conversoes',
        loadChildren: () =>
          import('./features/extrator/novas-conversoes/novas-conversoes.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'NovasConversoes' },
      },
      {
        path: 'mapeamento/validacao-regras',
        loadChildren: () =>
          import('./features/extrator/novas-conversoes/validacao-parsers.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'ValidacaoParsers' },
      },
      // Endereço antigo da validação (links salvos).
      { path: 'validacao-parsers', redirectTo: 'mapeamento/validacao-regras', pathMatch: 'full' },
      {
        path: 'extrator',
        loadChildren: () =>
          import('./features/extrator/extrator-empreendimento/extrator.routes').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'Extrator' },
      },
      {
        path: 'logs',
        loadChildren: () =>
          import('./features/logs/logs.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'Log' },
      },
      {
        path: 'extratos-bancarios-nao-identificados',
        loadChildren: () =>
          import('./features/extrato-bancario-nao-identificado/extrato-bancario-nao-identificado.routes').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'ArquivosNaoMapeados' },
      },
      {
        path: 'vinculos',
        loadChildren: () =>
          import('./features/vinculos/vinculos.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'GerenciamentoVinculos' },
      },
      {
        path: 'usuarios',
        loadChildren: () =>
          import('./features/cadastros/usuarios/usuarios.routes').then(
            (m) => m.USUARIOS_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'Usuarios' },
      },
      {
        path: 'cadastro-contas',
        loadChildren: () =>
          import('./features/cadastros/contas/contas.routes').then((m) => m.CONTAS_ROUTES),
        canActivate: [permissionGuard],
        data: { permissao: 'Empreendimentos' },
      },
      {
        path: 'cadastro-operacoes',
        loadChildren: () =>
          import('./features/cadastros/operacoes/operacoes.routes').then(
            (m) => m.OPERACOES_CADASTRO_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'Empreendimentos' },
      },
      // Securitizadora virou parte do cadastro de Empresa.
      { path: 'securitizadora', redirectTo: 'empresa', pathMatch: 'full' },
      {
        path: 'credenciais-operador',
        loadChildren: () =>
          import('./features/cadastros/credenciais-operador/credenciais-operador.routes').then(
            (m) => m.CREDENCIAIS_OPERADOR_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'CredenciaisOperador' },
      },
      {
        path: 'integracoes-sienge',
        loadChildren: () =>
          import('./features/cadastros/integracoes-sienge/integracoes-sienge.routes').then(
            (m) => m.INTEGRACOES_SIENGE_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'IntegracaoSienge' },
      },
      {
        path: 'perfil',
        loadChildren: () =>
          import('./features/cadastros/perfil/perfil.routes').then(
            (m) => m.PERFIL_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'GerenciarAcesso' },
      },
      {
        path: 'permissoes',
        loadChildren: () =>
          import('./features/cadastros/permissoes/permissoes.routes').then(
            (m) => m.PERMISSOES_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'GerenciarAcesso' },
      },
      {
        // Tela administrativa que lista as sessoes de operacao ativas e
        // permite ao admin liberar (kick) uma sessao alheia. Mesma
        // permissao das outras telas de Gerenciar Acessos.
        path: 'sessoes-operacao',
        loadChildren: () =>
          import('./features/cadastros/sessoes-operacao/sessoes-operacao.routes').then(
            (m) => m.SESSOES_OPERACAO_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'GerenciarAcesso' },
      },
      {
        path: 'auditor-contrato',
        loadChildren: () =>
          import('./features/auditor-contrato/auditor-contrato.routes').then(
            (m) => m.AUDITOR_CONTRATO_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'AuditorContrato' },
      },
      {
        path: 'auditor-financeiro',
        loadChildren: () =>
          import('./features/auditor-financeiro/auditor-financeiro.routes').then(
            (m) => m.AUDITOR_FINANCEIRO_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'AuditorFinanceiro' },
      },
      {
        path: 'engenharia/conciliacao-financeira-obras',
        loadChildren: () =>
          import(
            './features/engenharia/conciliacao-financeira-obras/conciliacao-financeira-obras.routes'
          ).then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'ConciliacaoFinanceiraObras' },
      },
      {
        path: 'engenharia/auditor-fiscal',
        loadChildren: () =>
          import('./features/engenharia/auditor-fiscal/auditor-fiscal.routes').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'AuditorFiscal' },
      },
      {
        path: 'engenharia/contas-pagas',
        loadChildren: () =>
          import('./features/engenharia/contas-pagas/contas-pagas.routes').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'ContasPagas' },
      },
      {
        path: 'engenharia/conciliador-notas',
        loadChildren: () =>
          import('./features/engenharia/conciliador-notas/conciliador-notas.routes').then(
            (m) => m.CONCILIADOR_NOTAS_ROUTES,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'ConciliadorNotas' },
      },
      {
        path: 'monitor-obras/upload-arquivos',
        loadChildren: () =>
          import('./features/monitor-obras/upload-arquivos/upload-arquivos.routes').then(
            (m) => m.routes,
          ),
        canActivate: [permissionGuard],
        data: { permissao: 'MonitorObrasUpload' },
      },
      {
        path: 'monitor-obras/consulta',
        loadChildren: () =>
          import('./features/monitor-obras/consulta/consulta.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'MonitorObrasConsulta' },
      },
      {
        path: 'importacao/importar-brm',
        loadChildren: () =>
          import('./features/importacao/importar-brm/importar-brm.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'ImportacaoBRM' },
      },
      {
        path: 'importacao/importar-operacao',
        loadChildren: () =>
          import('./features/importacao/importar-operacao/importar-operacao.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'ImportacaoOperacao' },
      },
      {
        // VistoMob: vistoria/medição física de obra (app mobile). Cenários PMC,
        // Medições (e o detalhe do que o app coletou) e Vistoriadores - uma
        // única permissão de tela para tudo.
        path: 'vistomob',
        loadChildren: () =>
          import('./features/vistomob/vistomob.routes').then((m) => m.VISTOMOB_ROUTES),
        canActivate: [permissionGuard],
        data: { permissao: 'VistoMob' },
      },
      {
        path: 'api-externa/usuarios',
        loadChildren: () =>
          import('./features/api-externa/usuarios-externos/usuarios-externos.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'UsuariosExternos' },
      },
      {
        path: 'api-externa/vinculos',
        loadChildren: () =>
          import('./features/api-externa/vincular-acessos/vincular-acessos.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'UsuariosExternos' },
      },
      {
        path: 'api-externa/consumo',
        loadChildren: () =>
          import('./features/api-externa/consumo-api/consumo-api.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'ConsumoApiExterna' },
      },
      {
        path: 'api-externa/documentacao',
        loadChildren: () =>
          import('./features/api-externa/documentacao/documentacao.routes').then((m) => m.routes),
        canActivate: [permissionGuard],
        data: { permissao: 'UsuariosExternos' },
      },
      {
        path: '',
        pathMatch: 'full',
        canActivate: [landingGuard],
        children: [],
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'login',
  },
];
